/** Start after load + idle, or the first interaction; never more than once. */
export function afterPageIdle(callback: () => void): () => void {
  let started = false;
  let idle: number | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;
  function cleanup() {
    window.removeEventListener("load", schedule);
    events.forEach((event) => window.removeEventListener(event, start));
    if (idle !== undefined) window.cancelIdleCallback?.(idle);
    if (timer !== undefined) clearTimeout(timer);
  }
  function start() {
    if (started) return;
    started = true;
    cleanup();
    callback();
  }
  function schedule() {
    if (window.requestIdleCallback) idle = window.requestIdleCallback(start, { timeout: 3000 });
    else timer = setTimeout(start, 1);
  }
  events.forEach((event) => window.addEventListener(event, start, { once: true, passive: true }));
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
  return cleanup;
}
